'use client';

import { useMemo } from 'react';
import { useLocale } from 'next-intl';

//* Context
import { withLanguageContext } from '@/context';

//* Helpers
import { config } from '@/helpers';

//* Components
import Text from '../Text';
import CustomLink from '../CustomLink';
import Icon from '../Icon';

//* Styles
import FooterStyle from './style';

//* Data
import { globalData } from '@/data/globalData';

const Footer = ({ translate }) => {
	const lang = useLocale();

	const currentYear = new Date().getFullYear();
	const difference = currentYear - 2010;

	const footerMenuItems = useMemo(() => {
		return Object.values(config.routes).map((route, index) => {
			return (
				<Text
					key={index}
					className={'p p2 text-secondary-color footer-menu-item'}>
					<CustomLink
						url={route.path}
						content={route.name}
						className={'footer-menu-item-link hover-line'}
					/>
				</Text>
			);
		});
	});

	return (
		<FooterStyle>
			<div className={`footer-inner-wrapper`}>
				<div className={`footer-top-wrapper`}>
					<div className={`footer-block left`}>
						<div className='menu-item-block'>{footerMenuItems}</div>

						<div className='social-block'>
							<div className='social-inner-block'>
								<Text
									className={`h6 font-montserrat-arm-medium hover-primary-color follow-us uppercase`}
									text={'followUs'}
								/>

								<div className='svg-block'>
									<CustomLink
										external
										url={globalData.socials.facebook}>
										<Icon name='facebook' />
									</CustomLink>

									<CustomLink
										external
										url={globalData.socials.instagram}>
										<Icon name='instagram' />
									</CustomLink>
								</div>
							</div>
						</div>
					</div>

					<div className={`footer-block right`}>
						<div className={`footer-inner-block`}>
							<Text
								className={`h6 font-montserrat-arm-medium hover-primary-color footer-our-contacts align-right uppercase`}
								text={'ourContacts'}
							/>

							<div className={`footer-contact-data-block`}>
								<Text className={`p p2 text-secondary-color footer-address align-right`}>{globalData[lang].address}</Text>

								<Text className={`p p2 text-secondary-color footer-email align-right`}>
									<CustomLink
										external
										content={globalData.email}
										url={`mailto:${globalData.email}`}
										className={`hover-line`}
									/>
								</Text>

								{globalData.phone.map((item, index) => {
									return (
										<Text
											key={index}
											className={`p p2 text-secondary-color footer-phone align-right`}>
											<CustomLink
												external
												content={item.name}
												url={`tel:${item.value}`}
												className={`hover-line`}
											/>
										</Text>
									);
								})}
							</div>
						</div>
					</div>
				</div>

				<div className={`footer-bottom-wrapper`}>
					<Text className={`font-montserrat-arm-medium h6 hover-primary-color footer-bottom-text`}>
						{translate('officeInfo1')} {difference} {translate('officeInfo2')}
					</Text>

					<Text className={'p p2 text-secondary-color align-center office-name'}>
						<CustomLink
							external
							content={'#NetSpace'}
							className={'hover-line'}
							url={globalData.googleSearchLink}
						/>
					</Text>
				</div>

				<div className={`footer-bottom-wrapper`}>
					<Text className={`p p2 font-montserrat-arm-medium text-secondary-color footer-bottom-text`}>
						© {currentYear} {translate('footerBottomText')}
					</Text>
				</div>
			</div>
		</FooterStyle>
	);
};

export default withLanguageContext(Footer, ['translate']);
